import React from 'react';

import { useClassName } from 'common/hooks';
import useCustomStyle from '../../hooks';
import { toStyleObject } from '../../utils';

import './carousel-controls.less';

export default function CarouselControls({ children, settings }) {
  const classNames = useClassName('CLPCarouselControls');
  const [, customStyle] = useCustomStyle(settings);

  const carouselControlsStyles = toStyleObject(
    Object.fromEntries(
      Object.entries(customStyle)
        .filter(([key]) => key.startsWith('--carousel-controls-'))
        .map(([key, value]) => [key.replace('--carousel-controls-', ''), value])
    )
  );

  return (
    <div className={classNames('container')} style={carouselControlsStyles}>
      {children}
    </div>
  );
}
